module.exports = __webpack_public_path__ + "assets/img/item01.18aa099e.svg";